import { QuestionnaireTemplateId } from '@exam-center/graphql';

export const QUESTIONNAIRE_TEMPLATE_OPTIONS: {
  label: string;
  value: QuestionnaireTemplateId;
}[] = [
  { label: 'Standard', value: QuestionnaireTemplateId.TemplateA },
  { label: 'Long Form', value: QuestionnaireTemplateId.TemplateB },
  { label: 'Short Form', value: QuestionnaireTemplateId.TemplateC },
];

export const QUESTIONNAIRE_TEMPLATE_LABEL_MAP: Record<QuestionnaireTemplateId, string> =
  Object.fromEntries(
    QUESTIONNAIRE_TEMPLATE_OPTIONS.map(({ value, label }) => [value, label]),
  ) as Record<QuestionnaireTemplateId, string>;
